import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  appendSectionHeadlineReveal,
  SECTION_HEADLINE_DURATION,
} from "./section-headline-gsap.js";

gsap.registerPlugin(ScrollTrigger);

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

/** Body copy: starts slightly after the headline tween (same beat as property-slider slides). */
const TEXT_DELAY_AFTER_HEADLINE = 0.28;
const TEXT_INITIAL_Y = 24;

if (!reducedMotion) {
  document.querySelectorAll(".text-section").forEach((section) => {
    const headline = section.querySelector(".text-section__headline");
    const bodyEl = section.querySelector(".text-section__text");

    if (!headline && !bodyEl) {
      return;
    }

    gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 85%",
          toggleActions: "play none none none",
        },
        defaults: { ease: "power2.out" },
      });

      if (headline) {
        appendSectionHeadlineReveal(tl, headline, 0, { withRule: true });
      }

      if (bodyEl) {
        const bodyPosition = headline ? TEXT_DELAY_AFTER_HEADLINE : 0;
        tl.fromTo(
          bodyEl,
          { autoAlpha: 0, y: TEXT_INITIAL_Y },
          {
            autoAlpha: 1,
            y: 0,
            duration: SECTION_HEADLINE_DURATION,
            ease: "power2.out",
            force3D: true,
          },
          bodyPosition,
        );
      }
    }, section);
  });
}
